import miter from './helpers/miter-limit.js'
import Symbol2d from '../2d.js'
import tipLock from './helpers/tip-lock.js'

export default class Arrow extends Symbol2d {

  static mixins = [tipLock]

  handles = [{
    defaults: [.55, .28],
    constraints: [
      [0, 1], [0, .49]
    ],
    cursor: 'all-scroll'
  }]

  getMiter (d, dimensions, handles) {
    const miterLength = miter(d.path) * this.data.strokeWidth
    const length = handles[0].coords[1] * dimensions.height

    if (length + miterLength > dimensions.height / 2 - this.data.strokeWidth){
      // The miter length would make the stroke extend beyond the bounds of the
      // symbol, so we need to scale it down, so use the default browser miterlimit (4)
      return null
    } else {
      return miterLength
    }
  }

  path (dimensions) {
    const start = [0, dimensions.center[1] - this._pointer.width / 2]

    this._path.moveTo(...start)
    this._pointer(start, 'east')
    this._path.lineTo(...start)
    this._path.closePath()

    return this._path.toString()
  }

  textContainer (dimensions, handles) {
    // Find the x coordinate where the top base of the pointer intersects arrow diagonal line
    const pt1 = [dimensions.width - this._pointer.height, 0]
    const pt2 = [dimensions.width, dimensions.center[1]]
    const y = dimensions.height * handles[0][1]

    // Calculate slope (m)
    const m = (pt2[1] - pt1[1]) / (pt2[0] - pt1[0])
    // Calculate y-intercept (b)
    const b = pt1[1] - m * pt1[0]
    // Calculate x for a given y
    const x = (y - b) / m

    return {
      center: [x / 2, dimensions.center[1]],
      width: x,
      height: this._pointer.width,
    }
  }

}
